import { jsxs as w, jsx as o } from "react/jsx-runtime";
import { useTranslation as x } from "../../hooks/useTranslation/index.js";
import { DropdownListSide as C } from "../Dropdown/components/DropdownList/index.js";
import { NotificationBarCenter as D } from "./NotificationBarCenter/index.js";
import { NotificationBarIcon as g } from "./NotificationBarIcon/index.js";
import { CustomDropdownRoot as N, CustomDropdownList as T } from "./style.js";
import { Dropdown as t } from "../Dropdown/index.js";
function v({
  notifications: r,
  loading: i,
  notificationCount: n,
  hasNextPage: e,
  getNotificationUrl: m,
  onBackClick: c,
  onLoadMore: a,
  onReadAllClick: f,
  onNotificationClick: p,
  onClickNotificationIcon: s,
  onClose: d,
  onOpen: u,
  shouldNotOpen: l,
  isThemeWrapperActive: B
}) {
  const { t: h } = x("common");
  return /* @__PURE__ */ w(N, { onClose: d, onOpen: u, children: [
    /* @__PURE__ */ o(
      t.TriggerButton,
      {
        title: h("notification-bar-title"),
        shouldNotOpen: l,
        children: /* @__PURE__ */ o(
          g,
          {
            onClick: s,
            count: n
          }
        )
      }
    ),
    /* @__PURE__ */ o(t.Overlay, {}),
    /* @__PURE__ */ o(
      T,
      {
        fixed: !0,
        omitBreathingSpace: !0,
        side: C.RIGHT,
        isThemeWrapperActive: B,
        children: /* @__PURE__ */ o(
          D,
          {
            notifications: r,
            loading: i,
            hasNextPage: e,
            onBackClick: c,
            onReadAllClick: f,
            onNotificationClick: p,
            onLoadMore: a,
            getNotificationUrl: m
          },
          0
        )
      }
    )
  ] });
}
export {
  v as NotificationBar
};
